import React, { Fragment } from 'react';
import classnames from 'classnames';
import { LtrtEntities } from 'client/data/models/long-term-road-test';
import { UnorderedList } from 'site-modules/shared/components/unordered-list/unordered-list';

export function LtrtSummary({ ltrtContent: { dataPoints, bullets } }) {
  const renderTable = classes => (
    <table className={classnames('w-100', classes)} cellPadding={0} cellSpacing={0}>
      <colgroup>
        <col width="50%" />
        <col width="50%" />
      </colgroup>
      <thead>
        <tr>
          {dataPoints.miles && <td className="label text-white">{dataPoints.milesDrivenTitle}</td>}
          {dataPoints.mpg && <td className="label text-white">{dataPoints.avgMpgTitle}</td>}
        </tr>
      </thead>
      <tbody>
        <tr>
          {dataPoints.miles && <td className="heading-4 fw-normal text-white">{dataPoints.miles}</td>}
          {dataPoints.mpg && <td className="heading-4 fw-normal text-white">{dataPoints.mpg}</td>}
        </tr>
      </tbody>
    </table>
  );

  return (
    <Fragment>
      {renderTable('mb-1_5')}
      <UnorderedList
        title={bullets.label}
        items={bullets.value}
        titleClasses="heading-5 mb-0_5 text-white"
        listClasses="mb-1_5 mb-md-1 ps-1 size-10 text-white"
        textClasses="size-16 align-middle"
        listItemClasses="mb-0_5"
      />
    </Fragment>
  );
}

LtrtSummary.propTypes = {
  ltrtContent: LtrtEntities.LtrtContent.isRequired,
};
